// 从响应头或 URL 解析文件名
export function getFilenameFromResponse(response: any): any {
  // 方案1：从 Content-Disposition 头提取（服务器需设置）
  const contentDisposition = response.headers['content-disposition'];
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?(.+?)"?$/);
    if (match) return decodeURI(match[1]);
  }

  // 方案2：从 URL 路径提取
  const url = new URL(response.config.url, window.location.origin);
  return url.pathname.split('/').pop();
}

export function downloadBlob({ filename, data }: any) {
  // 创建 Blob 对象并生成下载链接
  const blob = new Blob([data]);
  const downloadUrl = window.URL.createObjectURL(blob);
  // 创建隐藏的 <a> 标签触发下载
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = filename; // 设置下载文件名
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();

  // 清理内存
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
}

export function formatBlob(res: any) {
  return new Promise((resolve, reject) => {
    if (res.data instanceof Blob) {
      try {
        // 从响应头或 URL 中提取文件名
        const filename = getFilenameFromResponse(res) || 'downloaded-file';
        // 创建 Blob 对象并生成下载链接
        const blob = new Blob([res.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        // 创建隐藏的 <a> 标签触发下载
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename; // 设置下载文件名
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理内存
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

        resolve(true);
      } catch (err: any) {
        reject(err.message);
      }
    } else {
      reject();
    }
  });
}
